import React, { FC, useCallback, useState } from "react";
import webMercatorTiles from "web-mercator-tiles";
import F7 from "../../../utils/F7";
//import style from "../../../styles/tileDownloaderStyle";
import { DownloadState } from "../MapDownloadPage";

export function calculateTiles(state: DownloadState) {
  let tiles: ReturnType<typeof webMercatorTiles> = [];

  for (let zoom = state.startZoom!; zoom <= state.endZoom!; zoom++) {
    tiles = tiles.concat(
      webMercatorTiles(
        {
          left: state.extent![0],
          bottom: state.extent![1],
          right: state.extent![2],
          top: state.extent![3],
        },
        zoom,
      ),
    );
  }
  return tiles;
}

const MapDownloadStep3: FC<{ state: DownloadState; onNext: (values: Partial<DownloadState>) => void; onBack: () => void }> = ({
  state,
  onNext,
  onBack,
}) => {
  const tiles = calculateTiles(state);

  const [name, setName] = useState("");

  const buttonNextClick = useCallback(() => {
    if (!name || name.length < 3) {
      F7.alert("Please enter a name for this download (min 3 chars)", "Name is missing");
      return false;
    }
    onNext({ name });
  }, [name, onNext]);

  //const css = style;
  return (
    <div>
      <div className="list-block">
        <ul className="margintopminus20">
          <li>
            <div className="item-content">
              <div className="item-inner">
                <div className="item-input">
                  <input type="text" placeholder="Name this download" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="textalignleft">
        <strong>Zoomlevels</strong>
        <p>
          {state.startZoom} to {state.endZoom}
        </p>

        <strong>Number of tiles</strong>
        <p>{tiles.length}</p>

        <strong>Download size</strong>
        <p>{Math.round(tiles.length * 0.025 * 100) / 100}MB</p>

        <button onClick={onBack} className="button  button-fill pull-left buttonConfirm">
          Back
        </button>
        <button onClick={buttonNextClick} className="button  button-fill pull-right buttonConfirm">
          Next
        </button>
      </div>
    </div>
  );
};
//style={css.buttonConfirm}
export default MapDownloadStep3;
